import { createListSearch } from "./listSearch";
const fields = {
  company: ["companyName", "denomination"],
  contact: ["contactFirstname", "contactLastname", "contacts.firstname", "contacts.lastname", "contacts.profession"],
  phone: ["contactPhone", "phone", "contacts.phone", "contacts.mobile"],
  email: ["contactEMail", "email", "contacts.email"],
  address: ["address", "postCode", "town", "addressLivraison", "postCodeLivraison", "townLivraison", "addressFacturation", "postCodeFacturation", "townFacturation"],
  reference: ["siret", "pld"],
};
export const createClientSearch = (query, criterion = "all") => createListSearch(query, criterion === "all" ? Object.values(fields).flat() : fields[criterion] || []);
export const matchesClientSearch = (client, query, criterion = "all") => createClientSearch(query, criterion)(client);
